export class AuthorizeError extends Error {
  constructor(message?: string) {
    super(message);
  }
}

export class ForbiddenError extends Error {
  constructor(message?: string) {
    super(message);
  }
}

export class ServerError extends Error {
  constructor(message?: string) {
    super(message);
  }
}

export class PropertyBindError extends Error {
  constructor({ property }: { property: string }) {
    const message = `Property "${property}" is required but was not provided.`;
    super(message);
  }
}
